import { LayoutActions, ELayoutActions } from "@edp-store/actions/layout.actions";
import { ILayoutState, initialLayoutState } from "@edp-store/state/layout.state";

export function layoutReducers(state = initialLayoutState, action: LayoutActions): ILayoutState {
    switch (action.type) {
        case ELayoutActions.CloseSidebar: {
            return {
                ...state,
                showSidebar: false,
                openSublevel: !action.closeSublevel,
            };
        }

        case ELayoutActions.OpenSidebar: {
            return {
                ...state,
                showSidebar: true,
                openSublevel: action.openSublevel,
            };
        }

        case ELayoutActions.SelectOverlay: {
            return {
                ...state,
                selectOverlay: {
                    type: action.payload,
                    origin: action.origin
                }
            };
        }

        case ELayoutActions.SelectSidebarSublevel: {
            return {
                ...state,
                selectSidebarSublevel: action.payload,
            };
        }

        case ELayoutActions.ActiveItemSidebar: {
            return {
                ...state,
                activeItemSidebar: action.payload,
            };
        }

        case ELayoutActions.SetMainMenu: {
            return {
                ...state,
                mainMenu: action.payload,
            };
        }

        case ELayoutActions.SetTabMenu: {
            return {
                ...state,
                tabMenu: action.payload,
            };
        }

        case ELayoutActions.ShowLoader: {
            return {
                ...state,
                loaderCount: action.loader ? state.loaderCount + 1 : state.loaderCount > 0 ? state.loaderCount - 1 : 0,
            };
        }

        case ELayoutActions.SaveLastActiveRoute: {
            return {
                ...state,
                lastActiveRoute: action.activeRoute,
            };
        }

        case ELayoutActions.SetActiveMenuItem: {
            return {
                ...state,
                mainMenu: [...state.mainMenu].map(item => {
                    let newItem = { ...item };
                    if (item.name === action.payload) {
                        newItem = { ...item, isActive: true };
                    }
                    return newItem;
                }),
            };
        }

        case ELayoutActions.SetActiveSubMenuItem: {
            return {
                ...state,
                mainMenu: [...state.mainMenu].map(item => {
                    if (item.isActive) {
                        item = {
                            ...item,
                            submenu: item.submenu.map(submenu => {
                                return { ...submenu, isActive: submenu.name === action.payload };
                            }),
                        };
                    }
                    return item;
                }),
            };
        }

        case ELayoutActions.LastResponse: {
            return {
                ...state,
                lastResponse: action.response,
            };
        }

        case ELayoutActions.SetNeedLoadUserPoints: {
            return {
                ...state,
                needLoadUserPoints: action.payload,
            };
        }

        case ELayoutActions.SetHeaderAlert: {
            return {
                ...state,
                showAlert: action.payload,
            };
        }

        default: {
            return state;
        }
    }
}
